import {ref} from "vue";
import Delay from "~/ts/library/Delay";
import {MyTooltipOptionInterface} from "~/core-ui/vue/ui/my-tooltip/MyTooltipOptionInterface";

let virtualRef = ref<any>();
let options = ref<MyTooltipOptionInterface>();

export class MyTooltipClass {
    async show(ref: any, p: MyTooltipOptionInterface) {
        this.hide();
        try {
            if (p.delay) {
                await Delay.make(p.delay, "myTooltipShow", true);
            }
        } catch (e) {
            return;
        }
        virtualRef.value = ref;
        options.value = p;
    }

    hide() {
        (async () => {
            try {
                await Delay.make(1, "myTooltipShow", true);
            } catch (e) {
                return;
            }
        })();
        virtualRef.value = null;
        options.value = null;
    }

    get virtualRef() {
        return virtualRef.value;
    }

    get visible() {
        return !!this.virtualRef;
    }


    get options() {
        return options.value;
    }
}

export const MyTooltip = new MyTooltipClass();